import { FC, useContext } from 'react';
import { AlertPanelWrapper } from './AlertPanel.styles';
import { SearchContext } from '@zoopla/listing-search-context';
import {
    EditSavedSearchBanner,
    isShowEditSavedSearchBanner
} from '@zoopla/listing-search/banners/edit-saved-search';
import { useIsLoggedIn } from '@zoopla/redux-reducer-user';
import AlertPanelSimple from './AlertPanelSimple';
import AlertPanelAjax from './AlertPanelAjax';
import { AlertPanelProps } from './AlertPanel.types';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

const LSRP_SIDEBAR_MEDIA_QUERY = `@media only screen and (min-width: 1140px)`;
const getRems = (pixels: number) => `${+pixels / 16}rem`;

const SectionThatDisappearsWhenNoSideBar = styled.div<{ minWidth?: string }>(
    ({ minWidth }) => css`
        display: none;

        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            display: block;
            min-width: ${minWidth || getRems(299)};
        }
    `
);

const AlertContent: FC<React.PropsWithChildren<AlertPanelProps>> = ({
    links,
    onSimpleLinkClick,
    onAjaxLinkClick,
    taxonomy
}) => {
    const { state } = useContext(SearchContext);
    const isLoggedIn = useIsLoggedIn();

    const {
        userAlertId,
        savedSearchAndAlerts,
        previousSavedSearchUri,
        isEditSavedSearchBannerVisible
    } = state;

    const isSavedSearch = userAlertId !== null;
    const showEditSavedSearchBanner = isShowEditSavedSearchBanner(
        userAlertId,
        previousSavedSearchUri,
        savedSearchAndAlerts?.uri
    );

    return (
        <>
            {isSavedSearch ? (
                isLoggedIn &&
                isEditSavedSearchBannerVisible &&
                showEditSavedSearchBanner ? (
                    <SectionThatDisappearsWhenNoSideBar minWidth="0">
                        <AlertPanelWrapper
                            color="graphic-background-accent"
                            data-testid="edit-saved-search-cta-banner-panel"
                        >
                            <EditSavedSearchBanner />
                        </AlertPanelWrapper>
                    </SectionThatDisappearsWhenNoSideBar>
                ) : (
                    <AlertPanelSimple onSimpleLinkClick={onSimpleLinkClick} />
                )
            ) : null}

            <AlertPanelAjax
                links={links}
                onAjaxLinkClick={onAjaxLinkClick}
                onSimpleLinkClick={onSimpleLinkClick}
                isLoggedIn={isLoggedIn}
                taxonomy={taxonomy}
            />
        </>
    );
};

export default AlertContent;
